import _ from 'lodash-es';
import { arrayToSimpleObj } from '.';

export type SelectOptionType = {
  text: string | JSX.Element;
  value: any;
};

export type OptionsArrType = Array<SelectOptionType>;
type OptionsObjType = { [key: string]: Array<SelectOptionType> };

export type OptionsType = OptionsArrType | OptionsObjType;

/**
 * 针对options是什么值，执行什么函数
 * arrFn: 当options是数组时执行
 * objFn: 当options是对象时执行
 * params: 后面的为执行参数
 */
export const optionsDealwith = (
  data: OptionsType,
  arrFn: (value: SelectOptionType, index?: number) => void,
  objFn?: (key: string, value: Array<SelectOptionType>) => void,
) => {
  if (Array.isArray(data)) {
    return data.map(arrFn);
  }
  const result: Array<any> = [];
  _.forEach(data, (item: SelectOptionType[], key: string) => {
    result.push(objFn?.(key, item));
  });

  return result;
};

export const getAllKeys = (list: OptionsType) => {
  const result: Array<any> = [];
  const arrFn = ({ value }: any) => {
    result.push(value);
  };
  const objFn = (_key: any, element: OptionsType) => {
    result.concat(optionsDealwith(element, arrFn));
  };
  optionsDealwith(list, arrFn, objFn);
  return result;
};

export const optionsToMap = (list: OptionsType) => {
  if (Array.isArray(list)) {
    return arrayToSimpleObj(list);
  }

  let result = {};
  _.forEach(list, (element: any) => {
    const item = arrayToSimpleObj(element);
    result = { ...result, ...item };
  });

  return result;
};
